
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.972 8.77a3.424 3.424 0 00-.202-.67 5.159 5.159 0 00-.35-.682c-.59-1.002-1.326-1.88-2.147-2.689-.808-.822-1.686-1.558-2.687-2.149a5.796 5.796 0 00-.682-.35 3.215 3.215 0 00-.669-.203c-.376-.07-.714-.019-.97.3-.009.013-.268.27-.646.642a16 16 0 00-1.781-.215c-1.519-.095-2.548.098-3.138.588a1.5 1.5 0 00-.562 1.207c.01 1.14 1.512 1.782 2.64 2.164 1.271.433 2.724.721 3.466.85-.029.023.056-.072.25-.135a.89.89 0 01.905.208.876.876 0 01-1.238 1.239c-.044-.044-2.6-.689-3.857-1.128-.41-.142-.777-.288-1.1-.43-.612.604-1.224 1.207-1.833 1.81a.319.319 0 00-.041.051.637.637 0 00-.101.082c-.733.734.353 3.009 2.427 5.082 2.071 2.072 4.345 3.163 5.077 2.43.019-.02.038-.041.057-.064.038-.031.079-.07.13-.12.06-.06 6.708-6.81 6.752-6.844.322-.26.37-.597.3-.973zM4.404 4.534c0-.098.025-.155.1-.218.31-.256 1.15-.37 2.246-.303.262.016.514.04.741.066-.498.493-1.016 1.002-1.417 1.397-1.503-.525-1.66-.917-1.67-.942zm11.09 4.102c-.321.322-1.732-.566-3.153-1.985-1.418-1.419-2.308-2.834-1.983-3.156.322-.323 1.736.565 3.154 1.984 1.418 1.422 2.305 2.834 1.983 3.157zM18.375 16.697c0 1.272-1.018 2.303-2.273 2.303-1.255 0-2.273-1.03-2.273-2.303 0-1.094.888-2.993 1.82-3.897a.668.668 0 01.917-.014c1.057.943 1.809 2.797 1.809 3.911z","fill":"#000"}})])
          )
        }
      }
    